import { state as validationState } from '../store/store.validation';

export const onFieldValidated = (canonicalName, fieldName, isValid) => {
  const result = new Set<string>(validationState.fields[canonicalName]);

  if (isValid) {
    result.delete(fieldName);
  } else {
    result.add(fieldName);
  }

  validationState.fields = {
    ...validationState.fields,
    [canonicalName]: result,
  };
};

const actions = {
  onFieldValidated,
};

export const populateFromVehicleAnswers = () => {};

export { actions };
export default actions;
